import React from 'react';
import moment from 'moment';
import {useDispatch, useSelector} from 'react-redux';
import {Table, Card, Dropdown, Loader} from 'semantic-ui-react';
import {fullDate, shortYearDate} from '../../../common/constants/datesFormat';
import {pageSizes} from '../../../common/constants/lists';
import {Actions} from '../../../common/actions';
import TablePaginator from '../../../common/components/tablePaginator';

const OFFSET = 0;
const {
  fetchPrioritizationIndicesDetail,
  changePrioritizationIndicesListPage,
  changePrioritizationIndicesListPageSize,
} = Actions;

const Detail = ({list}) => {
  if (!list.length) {
    return (
      <Table.Row>
        <Table.Cell textAlign='center' colSpan={10}>
          No hay información para el rango de fechas solicitado
        </Table.Cell>
      </Table.Row>
    );
  }

  return list.map((element, index) => {
    const prioritizationDateFormatted = element.prioritizationDate ?
      moment(element.prioritizationDate).format(fullDate) :
      '';
    const invoiceDateFormatted = element.invoiceDate ?
      moment(element.invoiceDate).format(fullDate) :
      '';
    const availableDateFormatted = element.availableDate ?
      moment(element.availableDate).format(fullDate) :
      '';
    const salesOrderDateFormatted = element.salesOrderDate ?
      moment(element.salesOrderDate, shortYearDate).format(fullDate) :
      '';

    return (
      <Table.Row key={index} textAlign='center'>
        <Table.Cell className='client'>{element.clientName}</Table.Cell>
        <Table.Cell className='chassis'>{element.chassis}</Table.Cell>
        <Table.Cell className='katashiki'>
          {element.sfx}/{element.katashiki}
        </Table.Cell>
        <Table.Cell className='description'>{element.description}</Table.Cell>
        <Table.Cell className='date'>{prioritizationDateFormatted}</Table.Cell>
        <Table.Cell className='prioritization-by'>
          {element.prioritizationBy}
        </Table.Cell>
        <Table.Cell className='date'>{invoiceDateFormatted}</Table.Cell>
        <Table.Cell className='reserved-for'>{element.reservedFor}</Table.Cell>
        <Table.Cell className='date'>{availableDateFormatted}</Table.Cell>
        <Table.Cell className='date'>{salesOrderDateFormatted}</Table.Cell>
      </Table.Row>
    );
  });
};

const TableLoader = () => {
  return (
    <Table.Row>
      <Table.Cell colSpan='100%'>
        <Loader active inline='centered' />
      </Table.Cell>
    </Table.Row>
  );
};

const PrioritizationIndicesDetail = ({parameters}) => {
  const prioritizationIndices = useSelector(
    (state) => state.prioritizationIndices
  );
  const dispatch = useDispatch();
  const {pageSize, pageNumber, loading, list, itemsCount, downloading} =
    prioritizationIndices;

  function onPageClick(value) {
    dispatch(changePrioritizationIndicesListPage(value));
    dispatch(fetchPrioritizationIndicesDetail(parameters, pageSize, value));
  }

  function onPageSizeClick(event, data) {
    dispatch(changePrioritizationIndicesListPageSize(data.value));
    dispatch(fetchPrioritizationIndicesDetail(parameters, data.value, OFFSET));
  }

  return (
    <Card fluid raised>
      <div className='horizontal-scroll'>
        <Table striped className='prioritization-indices-detail-table'>
          <Table.Header>
            <Table.Row textAlign='center'>
              <Table.HeaderCell>Cliente</Table.HeaderCell>
              <Table.HeaderCell>Chasis</Table.HeaderCell>
              <Table.HeaderCell>Katashiki</Table.HeaderCell>
              <Table.HeaderCell>Descripción</Table.HeaderCell>
              <Table.HeaderCell>Fecha Priorización</Table.HeaderCell>
              <Table.HeaderCell>Priorizado Por</Table.HeaderCell>
              <Table.HeaderCell>Fecha Facturación</Table.HeaderCell>
              <Table.HeaderCell>Reservado Para</Table.HeaderCell>
              <Table.HeaderCell>Fecha Disponible</Table.HeaderCell>
              <Table.HeaderCell>Fecha Orden Venta</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {(loading || downloading) ? <TableLoader /> : <Detail list={list} />}
          </Table.Body>

          {itemsCount > pageSize && (
            <Table.Footer>
              <Table.Row textAlign='center'>
                <Table.HeaderCell colSpan='100%'>
                  <div className='table-pagination'>
                    <span className='page-sizer'>
                      <strong>Items por página</strong>
                      <Dropdown
                        selection
                        upward
                        compact
                        value={pageSize}
                        options={pageSizes}
                        onChange={onPageSizeClick}
                      />
                    </span>
                    <TablePaginator
                      itemsCount={itemsCount}
                      itemsPerPage={pageSize}
                      selectedPage={pageNumber}
                      onOptionClick={onPageClick}
                    />
                  </div>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          )}
        </Table>
      </div>
    </Card>
  );
};

export default PrioritizationIndicesDetail;
